import { useEffect, useState, useSyncExternalStore } from "react";
import { Loader2 } from "lucide-react";
import { routeLoading } from "@/lib/routeLoading";

/** Délai avant d'afficher le voile : une page qui arrive vite ne le montre pas. */
const DELAY_MS = 150;

/**
 * Voile posé sur la page affichée pendant que la suivante se télécharge :
 * la page reste lisible, mais on voit qu'autre chose arrive, et un second
 * clic ne part pas dans le vide.
 */
export function RouteLoadingOverlay() {
  const loading = useSyncExternalStore(
    routeLoading.subscribe,
    routeLoading.isLoading,
    () => false,
  );
  return loading ? <Veil /> : null;
}

function Veil() {
  const [shown, setShown] = useState(false);
  useEffect(() => {
    const timer = setTimeout(() => setShown(true), DELAY_MS);
    return () => clearTimeout(timer);
  }, []);
  if (!shown) return null;
  return (
    <div
      role="status"
      className="fixed inset-0 z-[100] flex animate-fade-in cursor-progress items-center justify-center bg-canvas/50"
    >
      <p className="inline-flex items-center gap-2 rounded-full border border-border bg-surface px-4 py-2 text-sm font-medium text-muted-foreground shadow-raised">
        <Loader2 aria-hidden className="size-4 animate-spin text-action" />
        Chargement…
      </p>
    </div>
  );
}
